import React from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";
import useTranslation from "../../customHooks/translations";
import Grid from "@mui/material/Grid";
import {DEFAULT_THEME_COLOR} from "../../constants/theme";

const FreakHubUsersList = (props) => {
  const navigate = useNavigate();
  const translation = useTranslation();

  const calculateStyles = idx => {
    return {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: DEFAULT_THEME_COLOR
      }
    };
  };

  return (
    <>
      <List sx={{ width: '100%', maxWidth: '100%', bgcolor: 'background.paper' }}>
        {
          (props.data || []).map((item, idx) => (
            <>
              <ListItem
                alignItems="flex-start"
                onClick={() => navigate(`/@${item.username}`)}
                sx={calculateStyles(idx)}
              >
                <ListItemAvatar>
                  <Avatar alt={item.id} src={item.imageUrl || './icon-48x48.png'} />
                </ListItemAvatar>
                <Grid container>
                  <Grid container xs={12} sx={{ marginTop: 1, }}>
                    <React.Fragment>
                      {item.username}
                    </React.Fragment>
                  </Grid>
                  <Grid container xs={12}>
                    <React.Fragment>
                      <span style={{
                        color: 'grey',
                        fontSize: 12,
                      }}>
                        {`@${item.username}`}
                      </span>
                    </React.Fragment>
                  </Grid>
                </Grid>

              </ListItem>
              <Divider variant="inset" component="li" />
            </>
          ))
        }
      </List>
    </>
  )
};

export default FreakHubUsersList;
